import * as Yup from 'yup';

export const quickFormSchemaEdit = Yup.object().shape({
  currency: Yup.string().required('Currency is a required field'),
  priceGroup: Yup.string().required('Price Group is a required field'),
  salesRep: Yup.string().required('Sales Rep is a required field'),
  legalName: Yup.string().required('Legal Name is a required field'),
});
